import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class MustAskMoodApiQuery extends ApiQuery<boolean, void> {
	client = 'iam';
	document = gql`
		query MustAskMood {
			mustAskMood
		}
	`;
	method = 'mustAskMood';
}
